import ev from "../util/enumValue";

enum WidgetType {
    TEXT = ev('TEXT', 1),
    RECTANGLE = ev('RECTANGLE', 2),
    CIRCLE = ev('CIRCLE', 3),
    IMAGE = ev('IMAGE', 4),
    VIDEO = ev('VIDEO', 5),
    LOGO = ev('LOGO', 6),
    PRODUCT_LIST = ev('PRODUCT_LIST', 7),
    PRODUCT = ev('PRODUCT', 8),
    PROMOTION = ev('PROMOTION', 9),
    TICKER = ev('TICKER', 10)
}

export default WidgetType;
